/**
 * Icon lookup map: maps string keys from FUNCTIONALITY_NAV to MUI icon component names.
 * Pure data module — no React imports. Icons are instantiated in getIcon().
 */

import { type ReactElement } from 'react';
import {
  AccountBalance as AccountBalanceIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  AccountTree as AccountTreeIcon,
  Article as ArticleIcon,
  AttachMoney as AttachMoneyIcon,
  Calculate as CalculateIcon,
  Category as CategoryIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
  CompareArrows as CompareArrowsIcon,
  Dashboard as DashboardIcon,
  DataObject as DataObjectIcon,
  FactCheck as FactCheckIcon,
  GridOn as GridOnIcon,
  Gavel as GavelIcon,
  Link as LinkIcon,
  HistoryEdu as HistoryEduIcon,
  MoneyOff as MoneyOffIcon,
  Percent as PercentIcon,
  PieChart as PieChartIcon,
  Receipt as ReceiptIcon,
  Security as SecurityIcon,
  Shield as ShieldIcon,
  ShowChart as ShowChartIcon,
  Summarize as SummarizeIcon,
  SwapVert as SwapVertIcon,
  TableChart as TableChartIcon,
  TrendingDown as TrendingDownIcon,
  MonitorHeart as MonitorHeartIcon,
  PlayArrow as PlayArrowIcon,
  Speed as SpeedIcon,
  MenuBook as MenuBookIcon,
  CloudUpload as CloudUploadIcon,
  Timeline as TimelineIcon,
  Hub as HubIcon,
  VerifiedUser as VerifiedUserIcon,
} from '@mui/icons-material';
import Visibility from '@mui/icons-material/Visibility';

export const ICON_MAP: Record<string, ReactElement> = {
  AccountBalance: <AccountBalanceIcon />,
  AccountBalanceWallet: <AccountBalanceWalletIcon />,
  AccountTree: <AccountTreeIcon />,
  Article: <ArticleIcon />,
  AttachMoney: <AttachMoneyIcon />,
  Calculate: <CalculateIcon />,
  Category: <CategoryIcon />,
  CheckCircleOutline: <CheckCircleOutlineIcon />,
  CompareArrows: <CompareArrowsIcon />,
  Dashboard: <DashboardIcon />,
  DataObject: <DataObjectIcon />,
  FactCheck: <FactCheckIcon />,
  GridOn: <GridOnIcon />,
  Gavel: <GavelIcon />,
  Link: <LinkIcon />,
  HistoryEdu: <HistoryEduIcon />,
  MoneyOff: <MoneyOffIcon />,
  Percent: <PercentIcon />,
  PieChart: <PieChartIcon />,
  Receipt: <ReceiptIcon />,
  Security: <SecurityIcon />,
  Shield: <ShieldIcon />,
  ShowChart: <ShowChartIcon />,
  Summarize: <SummarizeIcon />,
  SwapVert: <SwapVertIcon />,
  TableChart: <TableChartIcon />,
  TrendingDown: <TrendingDownIcon />,
  Visibility: <Visibility />,
  MonitorHeart: <MonitorHeartIcon />,
  PlayArrow: <PlayArrowIcon />,
  Speed: <SpeedIcon />,
  MenuBook: <MenuBookIcon />,
  CloudUpload: <CloudUploadIcon />,
  Timeline: <TimelineIcon />,
  Hub: <HubIcon />,
  VerifiedUser: <VerifiedUserIcon />,
};

export function getIcon(name: string): ReactElement {
  return ICON_MAP[name] ?? <DashboardIcon />;
}
